import { JsonObj } from '@mhp/general-interface';
import { DFDHeaders } from 'serverTypes/authentication';
import { MessagePool, ProviderSummary } from 'store/findProvider/types';

export interface MhpDetails {
  url?: string;
  headers?: {};
}

export interface MessageSummary {
  id: string;
  hasAttachment: boolean;
  subject: string;
  createDate: Date;
  messagePool: MessagePool;
  mhpDetails: MhpDetails;
  status: MessageStatus;
  receivers: MessageReceiver[];
  senderFirstName: string;
  senderMiddleName: string;
  senderLastName: string;
  senderFullName: string;
  senderProfileImageUrl: string;
  senderCernerPersonnelId: string;
  senderNcidId: string;
  senderPoolText: string;
  senderPoolName: string;
  senderDisplayName: string;
  source?: 'cdr' | 'cerner';
}

export enum MessageFolderType {
  Inbox = 'inbox',
  Outbox = 'outbox'
}

export enum MessagingDateFilterType {
  LAST_6 = 'Last 6 months',
  LAST_12 = 'Last 12 months',
  LAST_24 = 'Last 24 months',
  CUSTOM = 'Custom range'
}

export interface MessagingDateFilter {
  type: MessagingDateFilterType | null;
  start: Date;
  end: Date;
}

export interface MessageAttachment {
  mediaIdentifier: string;
  format: string;
  title: string;
  mhpDetails: MhpDetails;
}

export interface MessageDetail {
  source: string;
  id: string;
  subject: string;
  emailSender: string;
  receivers: MessageReceiver[];
  messageType: string;
  createDate: string;
  texts: MessageText[];
  attachments?: MessageAttachment[];
  senderCernerPersonnelId: string;
  senderDisplayName: string;
  senderProfileImageUrl: string;
  status: MessageStatus;
  messagePool: MessagePool;
  senderPoolName: string;
  allowReply: boolean;
}

export interface MessageReceiver {
  receiverId: number;
  type: string;
}

export interface MessageText {
  formatType?: string;
  text: string;
  plainText: string;
}

export interface MessageRecepient {
  receiverId: string | number;
  displayName: string;
}

export enum MessageStatus {
  UNREAD = 'UNREAD',
  OPENED = 'OPENED',
  ONHOLD = 'ONHOLD',
  DELETED = 'DELETED',
  COMPLETE = 'COMPLETE',
  UNKNOWN = 'UNKNOWN'
}
export interface Base64Attachment {
  base64: string;
  filename: string;
}

export interface MessageComposeScreenNavigationParams {
  subject?: string;
  readonly?: string | string[];
  message?: string;
  lockSubject?: boolean;
  hideMessage?: boolean;
  lockRecipient?: boolean;
  onSendSuccess?: () => void;
  recipient?: ProviderSummary;
  attachments?: Base64Attachment[];
  previousMessageId?: string;
  transmitParams?: {
    source?: string;
    payload?: JsonObj;
    returnBackTo?: string;
    returnBackToParams?: JsonObj;
    disable?: boolean;
  };
}

export interface CacheControlHeaders {
  [DFDHeaders.cacheControl]?: string;
  [DFDHeaders.mhpCacheControl]?: string;
}
